import { IUseAnalysisOneDimChartEntityOptions } from '../../type'
import { useAnalysisOneDimChartEntity } from '../useAnalysisOneDimChartEntity'

export function useAnalysisLiteratureOneDimChartEntity(options: Omit<IUseAnalysisOneDimChartEntityOptions, 'getChartConfig'>) {
  const getLineChartConfig: IUseAnalysisOneDimChartEntityOptions['getChartConfig'] = (type, config) => {
    const { aggField } = config

    if (aggField === 'YEAR') {
      return {
        categoryPicker: (item) => item.key,
        sorter: (a, b) => Number(a.key) - Number(b.key),
        /**
         * extended_bounds 从很早的年份开始补桶，最早一段没有文献的年份要裁掉，
         * 与专利趋势图「全部」时跳过开头连续 0 值的处理保持一致
         */
        serverDtoAdjust: (dto) => {
          const items = dto.items
          const firstNonzeroIndex = items.findIndex((item) => (item.count || 0) > 0)

          if (firstNonzeroIndex > 0) {
            dto.items = items.slice(firstNonzeroIndex)
          }

          return dto
        },
        /**
         * domain 默认把类目轴 interval 固定为 0，年份跨度大时标签会全部挤在一起；
         * 交回 echarts 的 auto，标签放不下时自动隔年显示
         */
        optionAdjust: (option) => {
          const xAxis = option.xAxis

          if (xAxis && !Array.isArray(xAxis) && xAxis.axisLabel) {
            // echarts 只在类目轴分支上声明 interval，domain 生成的正是类目轴，这里按该分支收窄
            ;(xAxis.axisLabel as { interval?: number | 'auto' }).interval = 'auto'
          }

          return option
        },
      }
    }
  }

  /**
   * 实体维度按文献数升序，配合横向布局后由下往上递减，与设计稿一致
   * 横向布局下类目名绘制在柱内上方，因此不开启 showLabel，并清掉与首条类目名重叠的 y 轴名称
   */
  const getBarChartConfig: IUseAnalysisOneDimChartEntityOptions['getChartConfig'] = () => {
    return {
      layout: 'horizontal',
      barMaxWidth: 20,
      sorter: (a, b) => (a.count || 0) - (b.count || 0),
      optionAdjust: (option) => ({
        ...option,
        yAxis: {
          ...option.yAxis,
          name: '',
        },
      }),
    }
  }

  const { chartEntity, dataList, countFieldName, categoryFieldName } = useAnalysisOneDimChartEntity({
    ...options,
    getChartConfig: (type, config) => {
      if (type === 'line') return getLineChartConfig(type, config)
      if (type === 'bar') return getBarChartConfig(type, config)
      return
    },
  })

  return {
    chartEntity,
    dataList,
    countFieldName,
    categoryFieldName,
  }
}
